<template>
  <div v-if="correct" class="enemy-card">
    <img :src="'images/profile/' + data.img + '.png'" alt="" />
    <div style="max-width: 128px">
      <strong>{{ data.name }}</strong>
    </div>
    <MDBBadge color="primary">Lv. {{ level }}</MDBBadge>
  </div>
  <div v-else-if="enemy == ''" class="enemy-card empty"></div>
  <div v-else class="enemy-card empty">{{enemy}}</div>
</template>

<script>
// import { useStore } from "vuex";
import { MDBBadge } from "mdb-vue-ui-kit";
export default {
  name: "EnemyFormationCard",
  props: {
    enemy: String,
    level: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    enemies() {
      return this.$store.getters.getEnemies;
    },
    correct() {
      return this.enemy in this.enemies;
    },
    data() {
      return this.enemies[this.enemy];
    },
  },
  components: { MDBBadge },
  async setup() {
    // const store = useStore();
    // await store.dispatch("init");
  },
};
</script>

<style scoped>
.enemy-card {
  background-color: #adb5bd;
  border-radius: 8px;
  line-height: 120%;
  padding: 1em;
  position: relative;
  cursor: pointer;
}
.empty {
  background-color: #dee2e6;
  pointer-events: none;
}
img {
  max-height: 100px;
  max-width: 100%;
}
</style>
